import React from "react";

const PastorIntro = () => {
  return (
    <section className="p-10 md:p-12 text-center bg-sky-800">
      <h2 className="text-3xl font-bold mb-4">Pastor's Introduction</h2>

      <p className="mb-6 max-w-2xl mx-auto text-lg">
        Welcome to today’s message. Let your heart be open to God's word.
      </p>

      <div className="flex justify-center">
        <div className="w-full max-w-3xl rounded-xl overflow-hidden shadow-lg">
          <video
            className="w-full h-auto"
            controls
          >
            <source src="/pastor-intro.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </section>
  );
};

export default PastorIntro;